module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1036-61a47945291e8ca7d3fb08131e5684be.png";